import { createContext, useReducer, useMemo } from 'react';

import reducer from './reducer';
import { AppContextType, AppStore } from './types';
import { getToken } from '../utils/token';

const initialState: AppContextType = {
  siderIsCollapsed: false,
  data: [],
  bulkAction: '',
  tabs: [],
  clonedTabs: [],
  tabsSorted: false,
  activeTab: null,
  allTabsHidden: false,
  addingRowIndex: -1,
  userProfile: null,
  loggedUser: getToken(),
  cellsUpdated: false,
  projectData: null,
  activePage: '',
  prevTabSlug: '',
  isTabChanged: false,
  insertedRows: { masterListId: null, ids: {} },
  userSettings: { visible: false, mode: 'none' }
};

export const AppContext = createContext<AppStore>([initialState]);

export const AppProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const store = useMemo<AppStore>(() => [state, dispatch], [state]);

  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};
